import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import { ACCOUNT_AND_USER_MENU } from './config';
import mapMenuItems from './utils/mapMenuItems';
import renderEnabledMenuItems from './utils/renderEnabledMenuItems';
import generateMenuPropTypes from './utils/generateMenuPropTypes';

import menuCloseHoverHandler from './MenuCloseHoverHandler';
import UserInfoDisplay from './UserInfoDisplay';
import AccountInfoDisplay from './AccountInfoDisplay';

import userPropTypes from './propTypes/user';

import styles from './AppHeader.scss';

const BASE_KEY = 'components.app_header.account_and_user_menu';
const ITEM_MAPPINGS = mapMenuItems(ACCOUNT_AND_USER_MENU.ITEMS, BASE_KEY);

const component = function AccountAndUserMenu(props) {
    const { user } = props;

    return (
        <div
            data-menu="user"
            className={`${styles['dropdown-container']} ${props.menuClassName}`}
            onMouseOver={props.showMenu}
        >
            <UserInfoDisplay user={user} />
            <div className={styles['dropdown-div']}>
                {user.accountTitle && <AccountInfoDisplay user={user} />}
                {renderEnabledMenuItems(ITEM_MAPPINGS, props, props.hideMenu)}
            </div>
        </div>
    );
};

component.displayName = displayName('AppHeader/AccountAndUserMenu');

component.propTypes = {
    ...generateMenuPropTypes(ITEM_MAPPINGS),
    ...UserInfoDisplay.propTypes,
    user: userPropTypes,
    menuClassName: PropTypes.string,
    showMenu: PropTypes.func.isRequired,
    hideMenu: PropTypes.func.isRequired,
};

component.defaultProps = {
    user: {},
    menuClassName: '',
};

const AccountAndUserMenu = menuCloseHoverHandler(component);

export default AccountAndUserMenu;
